// eslint-disable-next-line import/no-extraneous-dependencies
import PropTypes from 'prop-types';
import Mobile from 'components/Navbar/Mobile';
import Desktop from 'components/Navbar/Desktop';
import css from 'styled-jsx/css';
import { screen } from 'components/styles/variables';

/* istanbul ignore next */
const mobileVisible = css.resolve`
  nav {
    display: block;
  }
  @media screen and (min-width: ${screen.smMax}) {
    nav {
      display: none;
    }
  }
`;

/* istanbul ignore next */
const desktopVisible = css.resolve`
  nav {
    display: none;
  }
  @media screen and (min-width: ${screen.smMax}) {
    nav {
      display: inline-block;
    }
  }
`;

const Navbar = ({ currentItem }) => (
  <>
    <Desktop className={desktopVisible.className} currentItem={currentItem} />
    <Mobile className={mobileVisible.className} currentItem={currentItem} />
    {mobileVisible.styles}
    {desktopVisible.styles}
  </>
);

Navbar.propTypes = {
  currentItem: PropTypes.string,
};

export default Navbar;
